// extracted by mini-css-extract-plugin
export default {"icon":"HeaderIcon--icon--5vdLF"};